module.exports = __webpack_public_path__ + "static/media/027.c331209d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/027.jpg
// module id = 324
// module chunks = 0